import(/* webpackMode: "eager" */ "/home/devteam/haritweg/frontend/src/app/[locale]/register/page.js");
